import { render, staticRenderFns } from "./UnscheduledModelSideMenu.vue?vue&type=template&id=a479e7ca"
import script from "./UnscheduledModelSideMenu.vue?vue&type=script&lang=js"
export * from "./UnscheduledModelSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a479e7ca')) {
      api.createRecord('a479e7ca', component.options)
    } else {
      api.reload('a479e7ca', component.options)
    }
    module.hot.accept("./UnscheduledModelSideMenu.vue?vue&type=template&id=a479e7ca", function () {
      api.rerender('a479e7ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/unscheduledmodel/UnscheduledModelSideMenu.vue"
export default component.exports